import React from 'react';

export const AddWeight = () => {
    return (
        <div>
            Add Weight Page
        </div>
    );
};